import { IonCheckbox, IonToolbar } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { GenericMessages } from 'src/intl/GenericMessages';
import { ProfileMessages } from 'src/intl/ProfileMessages';
import { DqText } from '../dq-text';
import './FeedbackModal.scss';
import { AppModal } from '../reusable-components/app-modal/AppModal';
import { Textarea } from '../reusable-components/Textarea';

interface FeedbackModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the feedback.
   */
  onSave: (e: string | undefined, canContact: boolean) => void;
}
export const FeedbackModal: React.FC<FeedbackModalProps> = ({ onClose, isOpen, onSave }) => {
  const { formatMessage } = useIntl();

  const [feedbackText, setFeedbackText] = useState<string | undefined>(undefined);
  const [canContact, setCanContact] = useState<boolean>(false);

  useEffect(() => {
    setFeedbackText(undefined);
  }, [isOpen]);

  const submitButton = React.useMemo(() => {
    return {
      label: formatMessage(ProfileMessages.submitFeedback),
      onClick: () => onSave(feedbackText, canContact),
      disabled: !feedbackText,
    };
  }, [canContact, feedbackText, formatMessage, onSave]);

  const cancelButton = React.useMemo(() => {
    return {
      label: formatMessage(GenericMessages.cancelButtonLabel),
      onClick: onClose,
    };
  }, [formatMessage, onClose]);

  return (
    <AppModal
      className="feedback-modal"
      isOpen={isOpen}
      title={formatMessage(ProfileMessages.provideFeedback)}
      onClose={onClose}
      primaryButton={submitButton}
      secondaryButton={cancelButton}
      footerContent={
        <IonToolbar>
          <IonCheckbox
            className="feedback-checkbox"
            checked={canContact}
            onChange={e => setCanContact(!e.currentTarget.checked)}
            slot="start"
          />
          <DqText onClick={() => setCanContact(v => !v)}>{formatMessage(ProfileMessages.followUpOptIn)}</DqText>
        </IonToolbar>
      }
    >
      <DqText variant="body">{formatMessage(ProfileMessages.feedbackDescription)}</DqText>

      <div className="feedback-sign-off">
        <DqText variant="body">- {formatMessage(ProfileMessages.feedbackSignOff)}</DqText>
      </div>
      <Textarea
        value={feedbackText}
        placeholder={formatMessage(ProfileMessages.feedbackPlaceholder)}
        onChange={e => setFeedbackText(e.detail.value!)}
        id="feedback-input"
      />
    </AppModal>
  );
};
export default FeedbackModal;
